import {
  IconButton,
  Stack,
  Typography
} from '@mui/material';
import Box from '@mui/material/Box';
import React, {JSX} from 'react';
import {SupportCustomerPlanModel} from '../../../../model/support/support-customer-plan.model';
import HeadsetMicOutlinedIcon from '@mui/icons-material/HeadsetMicOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import {FormatUtils} from '../../../../utils/format.utils';

export type Props = {
  supportPlan: SupportCustomerPlanModel
  translate: (key: string) => string
  translateLocal: (key: string) => string
  onDrawerOpened: () => void
}

type HeaderItem = {
  icon: JSX.Element
  value: string
  title: string
}

export const SupportPlanDetailsHeader = ({supportPlan, translate, translateLocal, onDrawerOpened}: Props) => {
  const headerItems: HeaderItem[] = [
    { icon: <PeopleOutlinedIcon />, value: supportPlan.organizationName, title: translateLocal('header.customer')},
    { icon: <HeadsetMicOutlinedIcon />, value: translate(`support.plan.type.${supportPlan.planType}`), title: translateLocal('header.planType')},
    { icon: <AccessTimeOutlinedIcon />, value: supportPlan.monthlyHours.toString(), title: translateLocal('header.monthlyHours')},
    { icon: <AccessTimeOutlinedIcon />, value: FormatUtils.formatCurrency(supportPlan.monthlyCost), title: translateLocal('header.monthlyCost')},
  ]

  const buildSimpleHeaderItem = (item: HeaderItem, index: number) => {
    return <Box key={index} display="flex" alignItems="center" gap={1}>
      {item.icon}
      <Typography variant="body2" fontWeight="bold">
        {item.title}:
      </Typography>
      <Typography variant="body2">{item.value}</Typography>
    </Box>
  }

  return (
    <Stack direction="row" spacing={4} alignItems="center" justifyContent="space-between">
      <Stack direction="row" spacing={4} alignItems="center">
        {headerItems.map((item, index) => buildSimpleHeaderItem(item, index))}
      </Stack>
      <IconButton aria-label="edit" size="small" onClick={onDrawerOpened}>
        <EditOutlinedIcon />
      </IconButton>
    </Stack>
  );
}